import Controller from '@ember/controller';

export default class SavingsController extends Controller {
  queryParams = ['preserveScrollPosition'];
  preserveScrollPosition = true;
}
